/** The contact form: a placeholder that only says thank you. The message is read from the page. */
export function wireContactForm(form: HTMLFormElement) {
  const thankyou = form.dataset.thankyou ?? ''
  form.addEventListener('submit', (e) => {
    e.preventDefault()
    form.classList.add('sent')
    form.querySelector('button')!.textContent = thankyou
  })
}
